import { productVersionSelector } from '../../selectors/ProductsSelectors';

/**
 * Returns a comma separated string of quantity pack quantities in a list of product configurations,
 * filtered to just one product version by skuId
 */
export const seleniumUnitQuantitiesStringSelector = (state, {
  productConfigurations,
  productVersionSkuId
}) => {
  var _productVersionSelect;
  if (!productVersionSkuId) return '';
  const quantityPackDetails = productVersionSkuId ? (_productVersionSelect = productVersionSelector(state, {
    skuId: productVersionSkuId
  })) === null || _productVersionSelect === void 0 ? void 0 : _productVersionSelect.quantityPackDetails : [];
  return productConfigurations.filter(({
    skuId
  }) => quantityPackDetails === null || quantityPackDetails === void 0 ? void 0 : quantityPackDetails.some(({
    skuId: searchSkuId
  }) => searchSkuId === skuId)).map(({
    quantity
  }) => quantity).join(',');
};

/**
 * Returns a comma separated string of quantity pack unit types in a list of product configurations,
 * filtered to just one product version by skuId
 */
export const seleniumUnitsTypesStringSelector = (state, {
  productConfigurations,
  productVersionSkuId
}) => {
  var _productVersionSelect2;
  if (!productVersionSkuId) return '';
  const quantityPackDetails = productVersionSkuId ? (_productVersionSelect2 = productVersionSelector(state, {
    skuId: productVersionSkuId
  })) === null || _productVersionSelect2 === void 0 ? void 0 : _productVersionSelect2.quantityPackDetails : [];
  return productConfigurations.filter(({
    skuId
  }) => quantityPackDetails === null || quantityPackDetails === void 0 ? void 0 : quantityPackDetails.some(({
    skuId: searchSkuId
  }) => searchSkuId === skuId)).map(({
    skuId
  }) => {
    const details = quantityPackDetails === null || quantityPackDetails === void 0 ? void 0 : quantityPackDetails.find(({
      skuId: searchSkuId
    }) => searchSkuId === skuId);
    return details.quantityPackApiName;
  }).join(',');
};